let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ik6u5")).then(() => parcelRequire('iy7L3'));